import { FC } from 'react';
import { cn } from '@lib/utils.ts';
import { MinusIcon, PlusIcon } from 'lucide-react';

interface SectionToggleProps {
  toggle: boolean;
  onChange?: (toggle: boolean) => void;
  label?: string;
  className?: string;
}
export const SectionToggle: FC<SectionToggleProps> = ({
  toggle,
  onChange,
  label = 'Product Availability',
  className,
}) => {
  return (
    <div
      className={cn(
        'flex items-center lg:gap-5 gap-2.5 cursor-pointer',
        className
      )}
      onClick={() => onChange?.(!toggle)}
    >
      <div
        className={
          'h-4 w-4 rounded-full items-center justify-center flex bg-white text-black'
        }
      >
        {toggle ? <PlusIcon /> : <MinusIcon />}
      </div>
      <p>{label}</p>
    </div>
  );
};
